// Pack conversion DTOs — BUILD_SPEC.md §5.2 (pack_specs, consumed not owned by this
// goal), §8.5 (pack conversion flow: bagging pellets / boxing firelighters). Owned by
// G12 (plan.md) — this is the ONLY core file G12 fills; the barrel (schemas/index.ts)
// already re-exports it (S0).
//
// Status values follow the same DRAFT|POSTED|REVERSED lifecycle every other posted
// document in the spec uses. Deliberately NOT sourced from `@zebra/core/enums.ts`
// (out of this goal's registry rule — enums.ts is G2's foundation file) — see
// packages/core/src/schemas/stores.ts's header for the identical precedent.
import { z } from 'zod';
import { paginationRequestSchema, ulidSchema } from './common.js';
export const PACK_CONVERSION_STATUSES = ['DRAFT', 'POSTED', 'REVERSED'];
// `packSpecPackagingLineSchema` (one line of `pack_specs.packaging` jsonb) is now the
// SINGLE SOURCE OF TRUTH in schemas/common.ts (unified 2026-07-07, Wave 4 gate — see
// that file's doc comment for the config/packconv drift it fixes). Re-exported here so
// existing `@zebra/core` importers (services/api/src/modules/packconv/conversions.ts)
// are unaffected, and so config.ts and packconv both consume ONE definition.
export { packSpecPackagingLineSchema } from './common.js';
// ---------------------------------------------------------------------------
// Pack conversion header (create / update / response)
// ---------------------------------------------------------------------------
export const packConversionWriteSchema = z.object({
    packSpecId: ulidSchema,
    numPacks: z.number().int().positive('numPacks must be a positive whole number'),
    locationId: ulidSchema,
    occurredAt: z.coerce.date(),
    notes: z.string().nullable().optional(),
});
// Edit (PATCH, DRAFT-only) accepts the exact same shape as create — a full header
// replace, matching "documents are freely editable in DRAFT" (CLAUDE.md conventions).
export const packConversionUpdateSchema = packConversionWriteSchema;
export const packConversionResponseSchema = z.object({
    id: ulidSchema,
    tenantId: ulidSchema,
    siteId: ulidSchema,
    number: z.string(),
    status: z.enum(PACK_CONVERSION_STATUSES),
    packSpecId: ulidSchema,
    numPacks: z.number().int(),
    locationId: ulidSchema,
    occurredAt: z.coerce.date(),
    notes: z.string().nullable(),
});
export const packConversionListQuerySchema = paginationRequestSchema;
// ---------------------------------------------------------------------------
// Post / reverse responses
// ---------------------------------------------------------------------------
/** One `recordMovement` result surfaced back to the caller — `valueCents` transported
 * as a decimal string (JSON has no bigint), mirroring schemas/stores.ts's identical
 * convention. `type` narrows to the three movement types a pack conversion ever
 * books: PACK_OUT the bulk product, ISSUE per packaging consumable, PACK_IN the pack
 * product. */
export const packConversionMovementSummarySchema = z.object({
    type: z.enum(['PACK_OUT', 'ISSUE', 'PACK_IN']),
    productId: ulidSchema,
    qty: z.string(),
    valueCents: z.string(),
    movementId: ulidSchema,
});
export const packConversionPostResponseSchema = z.object({
    conversion: packConversionResponseSchema,
    movements: z.array(packConversionMovementSummarySchema),
    totalValueCents: z.string(),
    summary: z.string(),
});
export const packConversionReverseResponseSchema = z.object({
    conversion: packConversionResponseSchema,
    reversedMovementIds: z.array(ulidSchema),
});
//# sourceMappingURL=packconv.js.map